import { Injectable } from '@angular/core';
import { delay, of, type Observable } from 'rxjs';

import type {
  EmailPreviewClient,
  EmailPreviewRequest,
  EmailPreviewResponse,
} from '../tokens/email-preview-client.token';
import { buildMockEmailPreviewHtml } from '../../shared/utils/email-preview-mock-report.util';
import { getSameOriginBaseUrl } from '../../shared/utils/same-origin.utils';

@Injectable({ providedIn: 'root' })
export class EmailPreviewMockService implements EmailPreviewClient {
  getPreview(request: EmailPreviewRequest): Observable<EmailPreviewResponse> {
    const mockHtml = buildMockEmailPreviewHtml(
      request.model,
      getSameOriginBaseUrl(),
      request.includeAnalytics === true,
    );
    return of({ htmlBody: mockHtml } satisfies EmailPreviewResponse).pipe(delay(300));
  }
}
